import './index.scss'
import { useEffect } from 'react'
import ContentState from '../../../../stores/ContentState'
import { observer } from 'mobx-react'
const Cooperations = observer(() => {
  if (!ContentState.about?.coop) return <></>

  return (
    <section className="coop" id="coop">
      <div className="coop__container">
        <div className="coop__top">
          <div
            className="coop__title"
            dangerouslySetInnerHTML={{
              __html: ContentState.about.coop.title,
            }}
          ></div>
          <div
            className="coop__text"
            dangerouslySetInnerHTML={{ __html: ContentState.about.coop.text }}
          ></div>
        </div>
        <div className="coop__list">
          {ContentState.about.coop.list.slice(0, 15)?.map((c, i) => (
            <div className="coop__item" key={i}>
              <img src={c} />
            </div>
          ))}
        </div>
        <div className="coop__list">
          {ContentState.about.coop.list.slice(15)?.map((c, i) => (
            <div className="coop__item" key={i}>
              <img src={c} />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
})

export default Cooperations
